import * as yup from "yup";

import type { TFunction } from "i18next";

// Validación de la carga automática (semana/mes). Campos fijos, sin permisos.

/**
 * `projectId` sale como string: el `<Select>` de MUI entrega el id numérico del
 * `<MenuItem>` y `yup.string()` lo castea al validar, aunque el backend espere
 * `projectId` numérico en `ChargeHourDTO`.
 * Comportamiento preexistente (hallazgo previo a la migración); no se corrige
 * en esta migración tipo-only.
 */
export interface AutomaticChargeValues {
  projectId: string;
  typeOfCharge: string;
  hoursPerDay: number;
}

export const buildAutomaticChargeSchema = (t: TFunction): yup.ObjectSchema<AutomaticChargeValues> =>
  yup
    .object()
    .shape({
      projectId: yup.string().typeError(t("isRequired")).required(t("isRequired")),
      typeOfCharge: yup.string().typeError(t("isRequired")).required(t("isRequired")),
      hoursPerDay: yup.number().typeError(t("isRequired")).required(t("isRequired")),
    })
    .required();
